// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.code {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    padding: 20px;
    background-color: #000;
}

.code_input {
    box-sizing: border-box;
    width: 100%;
    max-width: 300px;
    margin: 10px 0;
    padding: 14px;
    border: 1px solid #333;
    border-radius: 6px;
    outline: none;
    background: #111;
    color: #fff;
    font-size: 18px;
}

.code_input:focus {
    border-color: #666;
}

.code_input_error {
    border-color: #f00 !important;
    outline: 2px solid #f00;
}

.login_button {
    position: relative;
    width: 100%;
    max-width: 300px;
    margin-top: 20px;
    padding: 14px;
    border-radius: 6px;
    background: #fff;
    color: #000;
    font-weight: bold;
    font-size: 18px;
    text-align: center;
    cursor: pointer;
    user-select: none;
}

.login_button:active {
    background: #ccc;
}

.spinner {
    z-index: 1;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 20px;
    height: 20px;
    transform: translate(-50%, -50%);
    border: 2px solid rgb(0 0 0 / 20%);
    border-radius: 50%;
    border-top-color: #000;
    animation: spin 0.6s linear infinite;
}

@keyframes spin {
    to {
        transform: translate(-50%, -50%) rotate(360deg);
    }
}
`, "",{"version":3,"sources":["webpack://./src/css/components/Code.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,kCAAkC;IAClC,kBAAkB;IAClB,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA;IACI;QACI,+CAA+C;IACnD;AACJ","sourcesContent":[".code {\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    min-height: 100vh;\n    padding: 20px;\n    background-color: #000;\n}\n\n.code_input {\n    box-sizing: border-box;\n    width: 100%;\n    max-width: 300px;\n    margin: 10px 0;\n    padding: 14px;\n    border: 1px solid #333;\n    border-radius: 6px;\n    outline: none;\n    background: #111;\n    color: #fff;\n    font-size: 18px;\n}\n\n.code_input:focus {\n    border-color: #666;\n}\n\n.code_input_error {\n    border-color: #f00 !important;\n    outline: 2px solid #f00;\n}\n\n.login_button {\n    position: relative;\n    width: 100%;\n    max-width: 300px;\n    margin-top: 20px;\n    padding: 14px;\n    border-radius: 6px;\n    background: #fff;\n    color: #000;\n    font-weight: bold;\n    font-size: 18px;\n    text-align: center;\n    cursor: pointer;\n    user-select: none;\n}\n\n.login_button:active {\n    background: #ccc;\n}\n\n.spinner {\n    z-index: 1;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 20px;\n    height: 20px;\n    transform: translate(-50%, -50%);\n    border: 2px solid rgb(0 0 0 / 20%);\n    border-radius: 50%;\n    border-top-color: #000;\n    animation: spin 0.6s linear infinite;\n}\n\n@keyframes spin {\n    to {\n        transform: translate(-50%, -50%) rotate(360deg);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
